import script from "./NotificationComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationComponent.vue?vue&type=script&setup=true&lang=js"

import "./NotificationComponent.vue?vue&type=style&index=0&id=9c25330e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c25330e"]])

export default __exports__